import { FormControlLabel, Grid, Switch } from "@mui/material";
import { FastField } from "formik";
import {
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea,
  MyTextFieldUploadFile,
  UploadAnhDaiDien,
  UploadMultiFile
} from "../../Lib/componentLibrarys";
import Api from "../../../api2";
import { useState } from "react";
import { isEmpty } from "lodash";
import ReactQuill from "react-quill";

export const FormNhap = ({ values, errors, setFieldValue, chuyenMucList }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      [{ size: ["small", false, "large", "huge"] }],
      [{ align: [] }],
      ["bold", "italic", "underline"],
      [{ color: [] }],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"]
    ]
  };
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
        <Grid item xs={12}>
          <FastField name="tieuDe">
            {({ field }) => (
              <MyTextField
                required
                label="Tiêu đề:"
                placeholder="Nhập..."
                errors={errors?.tieuDe}
                helperText={errors?.tieuDe}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12}>
          <FastField name="moTaNgan">
            {({ field }) => (
              <MyTextField
                label="Mô tả ngắn:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            required
            label="Chuyên mục:"
            placeholder="Chọn..."
            value={values?.chuyenMuc}
            options={chuyenMucList || []}
            name="tenChuyenMuc"
            onChange={(event, value) => {
              setFieldValue(`chuyenMuc`, value);
            }}
            errors={errors?.chuyenMuc}
            helperText={errors?.chuyenMuc}
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="url">
            {({ field }) => (
              <MyTextField label="URL:" placeholder="Nhập..." {...field} />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            style={{ marginLeft: 0.5, alignItems: "center", marginTop: 20 }}
            control={
              <Switch
                checked={values?.hienThi}
                onChange={(event, value) => {
                  setFieldValue("hienThi", value);
                }}
              />
            }
            label="Hiển thị tin tức"
          />
        </Grid>
        <Grid item xs={6}>
          <FormControlLabel
            style={{ marginLeft: 0.5, alignItems: "center", marginTop: 20 }}
            control={
              <Switch
                checked={values?.tin_NoiBat}
                onChange={(event, value) => {
                  setFieldValue("tin_NoiBat", value);
                }}
              />
            }
            label="Tin nổi bật"
          />
        </Grid>
        <Grid item xs={12}>
          <div
            style={{
              fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
              color: "#000000b3",
              fontSize: 15
            }}
          >
            Nội dung tin tức:
          </div>
          <ReactQuill
            value={values?.noiDung}
            onChange={value => setFieldValue("noiDung", value)}
            className="custom-quill"
            modules={modules}
            style={{
              maxHeight: "500px",
              overflowY: "auto",
              marginBottom: "8px"
            }}
          />
        </Grid>
        <Grid item xs={12} className="fileGiayChungNhan" style={{}}>
          <UploadAnhDaiDien
            multi={false}
            title="Ảnh đại diện tin tức:"
            titleBtnUpload="Tải lên ảnh"
            file={values?.fileImages || []}
            handleChangeFile={values => setFieldValue(`fileImages`, values)}
            checkSave={false}
          />
        </Grid>
      </Grid>
    </div>
  );
};
